import { render, staticRenderFns } from "./Scan.vue?vue&type=template&id=37cc78fe&scoped=true"
import script from "./Scan.vue?vue&type=script&lang=js"
export * from "./Scan.vue?vue&type=script&lang=js"
import style0 from "./Scan.vue?vue&type=style&index=0&id=37cc78fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cc78fe",
  null
  
)

export default component.exports